import React, { useState } from 'react'
import { useLocation } from "react-router-dom";
import moment from 'moment'



const Membership = ({ iframeId }) => {
    const location = useLocation();
    const memberships = location?.state?.memberships

  //  console.log(memberships)
    const [chosed, setChosed] = useState([])

    function appHeightChanged(iframeId, scrollToIframeTop = true, saveScroll = false, recoverScroll = false) {
        console.log('app height changed function')
        const app = document.querySelector('.login-profile')
      //  console.log(app.clientHeight)
        console.log(iframeId, 'iframe id')
        let height = app.clientHeight
        let newPageHeight = Math.max(app.scrollHeight, app.offsetHeight, app.clientHeight);

        if (iframeId !== null && (height != newPageHeight || saveScroll || recoverScroll)) {

            console.log('[CHILD] AppHeightChanged! Posting to parent: ');
            console.log({ iframeId, oldHeight: height, newHeight: newPageHeight, scrollToIframeTop, saveScroll, recoverScroll });

            window.parent.postMessage({
                iframeId: iframeId,
                iframeHeight: newPageHeight,
                scrollToTop: scrollToIframeTop,
                saveScroll: saveScroll,
                recoverScroll: recoverScroll
            }, '*');

        }

    }

    if (window.parent != window) {
        appHeightChanged(iframeId, true)
    }
    function handleArrow(e, item) {
        if (window.parent != window) {
            appHeightChanged(iframeId, true)
        }
        if (chosed.includes(item.No) === true) {
            let newarr = chosed.filter((i) => i !== item.No)
            setChosed(newarr)
        }
        else {
            let added = [...chosed, item.No]

            setChosed(added)
        }

       
       
    }
  
   // console.log(iframeId, 'iframeId')
 
    function checkDate(item) {
        let date = moment(moment(item.ExpireDate).format('YYYY-MM-DD')).diff(moment().startOf('day'), 'days')
       return date
    }
   
    return (
        <main className='Membership'>

            <p className='profile-title'> Medlemskaber </p>
            {memberships?.map((item) => {
                return       <div style={{
                border: chosed.includes(item.No) ? '1px solid rgba(153, 153, 153, 1)' : '', borderRadius: '4px',
                marginBottom: '25px'
            }}>
                    <div className='giftcards' onClick={(e) => handleArrow(e, item)} style={{ cursor: 'pointer', marginBottom: '0px' }}>
                    <p className='total'>{item.BonusName}</p>
                        <p className='club-name'>{ item.ClubName}</p>
                        <div className='date-container'> <p className='date' style={{width:'100%'} }>
                            {item.PaymentExpire === 0 ? 'Aktivt' : checkDate(item) < 0 ? 'Udløbet' :
                                checkDate(item)  + ' dage tilbage af dit medlemskab'}</p></div>
                    <div>
                       
                        <div>
                            {chosed.includes(item.No) ?
                                <svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18 9.5L9.5 1L1 9.5" stroke="white" />
                                </svg>


                                : <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18 1L9.5 9.5L1 0.999999" stroke="white" />
                                </svg>
                            }
                        </div>
                   
                </div>
                    </div>
                    {chosed.includes(item.No) ?
                        <>
                        <div className='giftcard-underdiv'>
                            <div>
                                    <p className='total-giftcards' style={{ color: 'rgba(241, 200, 149, 1)', fontWeight: 600 }}>Beskrivelse:</p>
                                    
                                <div className='memeberships-info'>
                                    <p>MEDLEMSFORDELE:</p>

                                </div>
                                    {item.PointSaldo > 0 ? <p className='saldo'>Saldo: {item.PointSaldo} point</p> : ''}
                            </div>
                                <div className='qrdiv' style={{ marginTop: '20px', opacity: item.PaymentExpire !== 0 &&  checkDate(item) < 0 ? '0.2' : ''} }>

                                    <img height='132px' style={{ borderRadius: '8px' }} src={`https://ebillet.dk/systemnative/barcode.asmx/QRBarCode?size=8&width=180&text=${item.CardNumber}`} />
                                    <p className='kode'>{item.CardNumber}</p>
                                </div>
                            <div className='dato_desc' style={{ fontSize: '14px' }}>
                                    <p>Oprettet {moment(item.CreateDate).format('DD/MM/YY')} </p>
                                    <p style={{ lineHeight: '5px' }}>{checkDate(item) > 0 ? 'Næste betaling '+ moment(item.ExpireDate).format(' DD-MM-YYYY') : ''}  </p>

                            </div>
                                <p style={{width:'20px'} }></p>
                         </div>
                          <div className='usage-histori'>
                                {item.MemberHistory.length > 0 ? <p className='title'>Forbrugshistorik; </p> : ''}
                                {item.MemberHistory.length > 0 ?
                                    item.MemberHistory.map((history) => {
                                        return <section className='history-trans'>
                                            <p>{moment(history.CreateDate).format('DD-MM-YYYY')} {moment(history.CreateDate).format('LT')}</p>
                                            <p>{history.Text}</p>
                                            <p style={{ display: 'flex' }}><span style={{ width: '30px', display: 'block', textAlign:'right',marginRight:'5px' }}>{history.Points}</span> point</p>
                                        </section>
                                    })
                                    : ''} 
                               
                            </div>
                        </>
                        :null}
                </div>
            })}
        </main>
    )
}

export default Membership